<template>
  <div class="legales-container" v-if="vista && vista.config.legales">
    <div class="legales-container--content" v-dompurify-html="vista.config.legales" />
  </div>
</template>

<script>
import Vue from 'vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
 
Vue.use(VueDOMPurifyHTML)

export default {
  name: "LegalText",
  data() {
    return {
      vista: null
    };
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getRoute,
      route => {
        this.vista = route.meta;
      },
      { immediate: true }
    );
  }
};
</script>

<style scoped>
.legales-container {
  margin-left: -17px;
  margin-right: -17px;
  background-color: #fafafa;
  padding: 40px 0 60px 0;
}
.legales-container--content {
  padding-left: 17px;
  padding-right: 17px;
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
}
.legales-container--content >>> p {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-size: 12px;
  line-height: 1.7em;
  margin-top: 0;
  margin-bottom: 1em;
}
.legales-container--content >>> h1,
.legales-container--content >>> h2,
.legales-container--content >>> h3 {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-size: 12px;
  margin-bottom: 1em;
  margin-top: 3em;
}
.legales-container--content >>> h1:first-child,
.legales-container--content >>> h2:first-child,
.legales-container--content >>> h3:first-child {
  margin-top: 0;
}
</style>
